import { Component, Input, OnInit } from '@angular/core';

import { CONTRIBUTION_TYPE } from '../../../_core/constants/Contribute';
import { COUNTRY_NAMES } from '../../../_core/constants/countries';
import { EnvironmentNames } from '../../../_core/constants/environments';
import FundTypes from '../../../_core/constants/fund-types';
import { Configuration } from '../../../app.constants';
import { ContributionTypes } from '../donate-form/donate-form.const';
import { ContributeDonorDisplayData } from '../donate-form/donate-form.model';

@Component({
  selector: 'app-summary-donation',
  templateUrl: './summary.component.html',
  styleUrls: ['./summary.component.scss'],
  standalone: false,
})
export class SummaryComponent implements OnInit {
  @Input() displayData: ContributeDonorDisplayData;
  @Input() redirected: boolean;
  @Input() dateFormat: string;
  @Input() fundName: string;
  @Input() hasTaxDeductionFund: boolean;
  @Input() contributionPurposeLabel: string;
  @Input() contributionPurposeRequired: boolean;

  environments = EnvironmentNames;
  contributionTypes = CONTRIBUTION_TYPE;
  environment: string;
  isSwiss: boolean;
  taxDeduction: string;
  contributionTypeText: string;

  get summaryFundName(): string {
    const contributionInfo = this.displayData.contributionInfo;
    return this.hasTaxDeductionFund ? contributionInfo.taxDeductionFund : this.fundName;
  }

  constructor(private config: Configuration) {
    this.environment = this.config.environmentName;
    this.isSwiss = this.environment === this.environments.SWISS;
  }

  ngOnInit(): void {
    this.displayTaxDeduction();
    this.setContributionType();
  }

  setContributionType(): void {
    const contributionType = ContributionTypes.find(
      (type) => type.code === this.displayData.contributionType
    );
    const isCanadaBankTransferOffline =
      contributionType?.code === CONTRIBUTION_TYPE.BANK_TRANSFER_OFFLINE &&
      this.displayData.contributionInfo?.countryDonatingFrom?.name === COUNTRY_NAMES.CANADA;
    this.contributionTypeText = isCanadaBankTransferOffline
      ? 'contribute.contribution_type.bank_transfer_offline_cncf'
      : contributionType?.displayName;
  }

  displayTaxDeduction(): void {
    this.taxDeduction =
      this.environment === this.environments.CNCF ||
      this.environment === this.environments.IGF ||
      this.environment === this.environments.GLF ||
      this.redirected ||
      this.displayData.contributionInfo.countryDonatingFrom?.name === COUNTRY_NAMES.UNITED_STATES ||
      this.displayData.contributionInfo.taxDeduction?.code
        ? 'Yes'
        : 'No';
  }
}
